import { Tooltip } from "components/common";
import { formatNumberWord } from "helpers/utils";
import { FaCaretDown, FaCaretUp, FaInfoCircle } from "react-icons/fa";
import SoftBadge from "components/common/SoftBadge";
import { Link } from "react-router-dom";
import React from 'react';
import PropTypes from 'prop-types';

const NumberWeightSummary = ({title, current_value, previous_value, isRevenue, handleClick, titleHeader}) => {

  const percent = previous_value > 0 ? ((current_value / previous_value) * 100)?.toFixed(0) : 0;
  const caretUp = current_value > previous_value;

  const formartNumberProject = (value) => {
    let newValue = formatNumberWord(parseInt(value || 0))

    return <span>
      <span className="tw-text-xl">{newValue}</span>{caretUp ? (<FaCaretUp className="tw-text-green-600" />) : (<FaCaretDown className="tw-text-red-600"/>)}
    </span>
  }

  return (
    <div
      className={`tw-h-full tw-rounded tw-shadow-sm tw-overflow-hidden ${isRevenue ? 'tw-bg-green-500' : 'tw-bg-white'}`}
      onClick={handleClick}
    >
      <div className="tw-p-4">
        <div className="tw-flex tw-justify-center tw-items-center tw-mb-3 tw-static">
          <h6 className={`tw-mb-0 tw-flex-1 ${isRevenue ? 'tw-text-white' : ''}`}>{title} <FaInfoCircle title={titleHeader} /></h6>
        </div>
        <div className="tw-flex tw-justify-between tw-items-center">
          <div className="font-sans-serif tw-leading-none tw-mb-2 tw-pr-2">
            <span className={`${isRevenue ? 'tw-text-white' : ''}`}>
              {formartNumberProject(current_value)}
            </span>
            <span className={`${isRevenue ? 'tw-text-slate-300' : 'tw-text-slate-500'} tw-text-xs tw-ml-1`}>
              vs {formatNumberWord(previous_value)}

              <Tooltip content="Compare with the same period in the previous year" placement="top">
                <span>
                  <FaInfoCircle className="tw-ml-1 tw-text-slate-400" />
                </span>
              </Tooltip>
            </span>
          </div>
          <div className={`tw-mb-2 ${caretUp ? 'tw-text-green-600' : 'tw-text-red-600'}`}>
            <SoftBadge pill bg={`${caretUp ? 'success' : 'danger'}`} className="tw-text-xs tw-font-bold">{percent}%</SoftBadge>
          </div>
        </div>

        {handleClick && (
          <div className="tw-text-xs tw-text-right tw-mt-3">
            <Link to="#" className="">View Detail</Link>
          </div>
        )}

      </div>
    </div>
  )
};

NumberWeightSummary.propTypes = {
  title: PropTypes.string.isRequired,
  current_value: PropTypes.number.isRequired,
  previous_value: PropTypes.number.isRequired,
  isRevenue: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  titleHeader: PropTypes.string
}

export default NumberWeightSummary;
